import { SET } from "@/stores/CommumActionTypes";
import { CREATE_LOCALE_KEY } from "./LocaleActionsTypes";
import { SetLocale } from "@/services/common/auth/RouterService";
import i18n from "@/i18n";

const actions = {
	[SET]({ commit }, locale)
	{
		if (i18n.locale === locale) return;
		const newLocale = SetLocale(locale);
		commit(SET, newLocale);
	},
	[CREATE_LOCALE_KEY]: ({ commit }) =>
	{
		const key = localStorage.getItem("locale");
		if (key === null)
		{
			localStorage.setItem("locale", "pt-BR");
			commit(SET, "pt-BR");
		}
	},
};

export default { actions };